import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedSeatMap = () => {
  return {
    car: { id: null, carGroup: {} },
    capacity: null,
    deckLevel: 1,
    rowSize: 5,
    colSize: 23,
    version: "1",
    name: "",
  };
};

let sessionId = window.name;
export default {
  state: () => ({
    selectedSeatMap: getDefaultSelectedSeatMap(),
    seatMaps: [],
    cabinClassCapacities: [],
  }),

  mutations: {
    setSelectedSeatMap(state, seatMap) {
      Vue.set(state, "selectedSeatMap", seatMap);
    },
    setSeatMaps(state, seatMaps) {
      Vue.set(state, "seatMaps", seatMaps);
    },
    setCabinClassCapacities(state, cabinClassCapacities) {
      Vue.set(state, "cabinClassCapacities", cabinClassCapacities);
    },
    setDefaultSelectedSeatMap(state) {
      Vue.set(state, "selectedSeatMap", getDefaultSelectedSeatMap());
    },
    setDefaultSeatMapModule(state) {
      Vue.set(state, "selectedSeatMap", getDefaultSelectedSeatMap());
      Vue.set(state, "seatMaps", []);
      Vue.set(state, "cabinClassCapacities", []);
    },
  },
  actions: {
    //TODO: load, update, create
    createOrUpdateSeatMap: (context, request) => {
      //console.log(request);
      return axios
        .post(context.getters.getMcServiceUrl + "/seat-map/entity", request)
        .then((response) => {
          context.commit("setSelectedSeatMap", response.data);
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadSeatMaps: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadSeatMap: (context, seatMapId) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/entity/" + seatMapId).then((response) => {
        // return objectUtils.convertPublishModelToUpdateModel(response.data);
        return response.data;
      });
    },

    loadSeatMapAccordingToDirection: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/seat-map/turnCar", request, {}).then((response) => {
        return response.data;
      });
    },

    loadPublishedSeatMaps: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/entity/published").then((response) => {
        return response.data;
      });
    },
    loadActiveSeatMaps: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/actives").then((response) => {
        return response.data;
      });
    },
    loadSeatMapHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/inventory/seat-map/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    loadSelectedSeatMapHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    searchSeatMapByStationId: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/inventory/seat-map/history/search", request, {}).then((response) => {
        return response.data;
      });
    },

    deleteSeatMap: (context, car) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/seat-map/entity/" + car.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          car.intents = intents;
          car.intentId = response.data.id;
          return car;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSeatMap: (context, car) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/seat-map/draft/" + car.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishSeatMap: (context, seatMap) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/publish/" + seatMap.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectSeatMap: (context, seatMap) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/reject/" + seatMap.intentId).then((response) => {
        if (seatMap.intents[0].type === "DELETE_SEAT_MAP") {
          seatMap.intents = null;
          seatMap.intentId = 0;
        } else if (seatMap.intents[0].type === "CREATE_SEAT_MAP") {
          seatMap.intents[0].status = "DRAFT";
        } else if (seatMap.intents[0].type === "UPDATE_SEAT_MAP") {
          seatMap.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallSeatMap: (context, seatMap) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/recall/" + seatMap.intentId).then((response) => {
        helper.recallOrRejectEntity(seatMap, "SEAT_MAP");
        return response.data;
      });
    },
    cancelSeatMap: (context, seatMap) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/cancel/" + seatMap.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalSeatMaps: (context, seatMap) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/sendToApproval/" + seatMap.intentId).then((response) => {
        if (seatMap.intents[0].type === "CREATE_SEAT_MAP") {
          seatMap.intents[0].status = "WAITING_APPROVAL";
        } else if (seatMap.intents[0].type === "UPDATE_SEAT_MAP") {
          seatMap.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    loadVagon: (context, templateId) => {
      return axios.get(context.getters.getServiceUrl + ":8103/seat-maps/seat-maps/filter/" + templateId).then((response) => {
        return response.data;
      });
    },
    loadAllocations: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/inventory/find-seat-map-allocations", request).then((response) => {
        return response.data;
      });
    },
    loadSeatMapsByTrainId: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/seat-maps/load-by-train-id", request, {
          headers: { Authorization: localStorage.getItem("AUTH_TOKEN"), "unit-id": context.getters.getSelectedUserUnitId },
        })
        .then((response) => {
          response.data.trainId = request.trainId;
          response.data.legIndex = request.legIndex;
          return response.data;
        });
    },
    loadSeatMapOccupancy: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/seat-maps/load-seat-map-occupancy", request).then((response) => {
        return response.data;
      });
    },
    selectSeat: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/inventory/select-seat", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err;
        });
    },
    // Toplu koltuk seçimi. Bacak bazındaki hatalar sonuç listesinde döner, sadece isteğin tamamı hatalıysa reject olur.
    selectSeats: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/inventory/select-seats", request).then((response) => {
        return response.data;
      });
    },
    checkSelectSeatPrice: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/inventory/check-seat-selection-prices", request).then((response) => {
        return response.data;
      });
    },
    releaseSeat: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/inventory/release-seat", request).then((response) => {
        return response.data;
      });
    },

    loadCabinClassCapacities: (context, templateIds) => {
      return axios.post(context.getters.getTmsServiceUrl + "/seat-maps/cabin-class-capacities", templateIds).then((response) => {
        let cabinClassCapacities = [];

        templateIds.forEach((templateId) => {
          response.data.forEach((cabinClassCapacity) => {
            if (templateId === cabinClassCapacity.seatMapTemplateId) {
              let filteredCabinClassCapacities = cabinClassCapacities.filter((_cabinClassCapacity) => {
                return _cabinClassCapacity.cabinClass.id === cabinClassCapacity.cabinClass.id;
              });

              if (filteredCabinClassCapacities.length === 1) {
                filteredCabinClassCapacities[0].count += cabinClassCapacity.count;
              } else {
                cabinClassCapacities.push(JSON.parse(JSON.stringify(cabinClassCapacity)));
              }
            }
          });
        });
        context.commit("setCabinClassCapacities", cabinClassCapacities);

        return cabinClassCapacities;
      });
    },
    checkSelectSeatPriceSimulation: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/inventory/check-seat-selection-prices-simulation", request).then((response) => {
        return response.data;
      });
    },
    checkUnlabelledSeats: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/seat-map/check-unlabelled/" + request.templateId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getCabinClassCapacities: (state) => {
      return state.cabinClassCapacities;
    },
    getSelectedSeatMap: (state) => {
      return state.selectedSeatMap;
    },
    getSeatMaps: (state) => {
      return state.seatMaps;
    },
  },
};
